import { BrandMark } from "./brand-mark.js";
import { engineMeta } from "./engines.js";

/**
 * An engine's mark in a row, a filter or a tile.
 *
 * logo.dev for most engines, the same as every brand. An engine whose domain
 * logo.dev cannot tell apart from another product carries its own glyph, or
 * the brand's own image where its mark is many colours (Gemini), instead: `gemini.google.com` comes back as Google's "G", which would put
 * Google's logo on every Gemini answer. An engine not in the table prints its
 * initial, never a borrowed logo.
 */
export function EngineLogo({
  engine,
  size = "sm",
}: {
  readonly engine: string;
  readonly size?: "sm" | "md" | "lg";
}) {
  const entry = engineMeta(engine);
  if (entry.glyph !== undefined && "src" in entry.glyph) {
    return (
      <span className={`brand-mark brand-mark-${size}`} aria-hidden="true">
        <img src={entry.glyph.src} alt="" width="100%" height="100%" />
      </span>
    );
  }
  if (entry.glyph !== undefined) {
    return (
      <span className={`brand-mark brand-mark-${size}`} aria-hidden="true">
        <svg
          viewBox="0 0 24 24"
          width="100%"
          height="100%"
          style={{ color: entry.glyph.color }}
        >
          <path d={entry.glyph.d} fill="currentColor" />
        </svg>
      </span>
    );
  }
  return <BrandMark name={entry.label} domain={entry.domain} size={size} />;
}
